export default __webpack_public_path__ + "static/media/Attack1.ed77a7b4.png";